// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__17zR1","title":"Info_title__grgDG","links":"Info_links__29WZW","link":"Info_link__2k46C","logo":"Info_logo__-4vxs"};